<bmcore-player [appType]="'PROD-PAGE'" [colorSettingsMode]="colorSettingsMode" [showShareBtn]="true"> </bmcore-player>
